import React, { Component } from "react";
import MediaField from "./MediaField";

class Media extends Component {
  state = {
    expandLabel: "See More",
  };

  constructor(props) {
    super(props);
    this.fieldElement = React.createRef();
  }

  render() {
    return (
      <div style={mediaStyle}>
        <div style={mediaHeaderContainerStyle}>
          <h1 style={mediaHeaderStyle}>Recent Media Contributions</h1>
          <MediaField
            media={this.props.media}
            blogs={this.props.blogs}
            ref={this.fieldElement}
          />
        </div>
      </div>
    );
  }
}

const mediaStyle = {
  height: "auto",
  width: "100%",
  background: "#eee",
  color: "#000",
  margin: "auto",
  padding: "0px 100px 30px 100px",
  display: "flex",
  flexWrap: "wrap",
  textAlign: "center",
};

const mediaHeaderContainerStyle = {
  margin: "30px auto",
};

const mediaHeaderStyle = {
  fontFamily: "Lora, serif",
  fontSize: "40px",
  margin: "20px auto",
};

export default Media;
